import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& .super-app-theme--header": {
      backgroundColor: "#C5E3C7",
      color: theme.palette.primary.main,
      maxWidth: "none !important",
    },
    "& .MuiDataGrid-footer": {
      backgroundColor: "#C5E3C7",
      color: theme.palette.primary.main,
    },
    "& .MuiDataGrid-cell": {
      padding: 0,
      minWidth: "0px !important",
      whiteSpace: "initial",
    },
    "& .MuiDataGrid-row": {
      width: "auto !important",
    },
    "& .MuiDataGrid-renderingZone": {
      width: "100% !important",
    },
    height: 200,
    flexGrow: 1,
    marginBlock: 10,
  },
  cell: {
    paddingLeft: "16px !important",
    maxWidth: "inherit !important",
    minWidth: "auto !important",
  },
  cellLot: {
    width: "12% !important",
  },
  cellResident: {
    width: "30% !important",
  },
  cellGuest: {
    width: "15% !important",
  },
  dateOfPass: {
    width: "15% !important",
  },
  cellComments: {
    width: "13% !important",
  },
  cellActions: {
    width: "15% !important",
  },
  cellFlex: {},
}));
